
import { SaleLayoutConf } from "@/models/sale-layout";
import { AuthService } from "@/services";
import { SaleService } from "@/services/sale-service";
import { EditorSettings } from "@/utils/sale-layouts/editor-settings";
import { HttpError } from "@/utils/services/http-error";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
export default FormLike.extend({
	data(){
		return {
			settings: new EditorSettings(),
			hasValidSaleId: true,
			onlyEditableBySupport: false
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayoutConf,
			required: true
		}
	},
	computed: {
		value():EditorSettings{
			return this.layout.Data.EditorSettings;
		},
		isSupportSession():boolean {
			return AuthService.isDevModeEnabled;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.settings = new EditorSettings(this.value.getJSON());
				this.onlyEditableBySupport = this.layout.OnlyEditableBySupport;
			}
		},
		hasValidSaleId: {
			immediate: true,
			handler(){
				this.validate();
			}
		}
	},
	methods: {
		extendValidate(){
			if (!this.hasValidSaleId) {
				this.isValid = false;
			}
		},
		async checkHasValidComputedId(){
			this.hasValidSaleId = false;
			if (this.settings.PreviewDocumentID.trim() == "") {
				this.settings.PreviewDocumentID = this.settings.PreviewDocumentID.trim();
				this.hasValidSaleId = true;
				return;
			}
			try{
				await SaleService.getByFriendlyId(this.settings.PreviewDocumentID);
				this.hasValidSaleId = true;
			}catch(err){
				let e = err as HttpError;
				e.dontShow = true;
				this.$wf.notify(this.$ct("cant-find-example-document").toString(), "warning", 3000, "exclamation-triangle");
			}
		},
		submit(){
			if (!this.isValid) return;
			this.layout.OnlyEditableBySupport = this.onlyEditableBySupport;
			this.layout.Data.EditorSettings = new EditorSettings(this.settings.getJSON());
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
